import { Card, ListGroup } from 'react-bootstrap';
import React from "react";
const Impressum = () => {
  return (
    <Card>
      <Card.Header as="h5">Verein</Card.Header>
      <Card.Body>
        <Card.Title>TSC Stahl Hennigsdorf e.V.</Card.Title>
        <ListGroup variant="flush">
          <ListGroup.Item>
            <strong>Vorsitzender:</strong> André Löchert
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Straße:</strong> Cheruskerweg 29
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Plz. / Ort:</strong> 14621 Schönwalde-Glien
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Land:</strong> Deutschland
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Email:</strong> vorstand[@]stahl-taucher.de
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Homepage:</strong> www.stahl-taucher.de
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Steuer Nr.:</strong> 053/140/00023; FA Oranienburg
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Aufsichtsbehörde:</strong> VR 1087 NP; Amtsgericht Neuruppin
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Mitglied im:</strong> VDST, LSB
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>VDST-Vereinsnummer:</strong> 13/4118
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>LSB-Mitgliedsnummer:</strong> 650103
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Online seit:</strong> 11.01.2007
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default Impressum;
